var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_ORDER = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const orderFragment_1 = require("../fragments/orderFragment");
exports.GET_ORDER = (0, graphql_tag_1.default) `
  query GET_ORDER($id: ID!) {
    node(id: $id) {
      ... on Order {
        ...OrderFragment
      }
    }
  }
  ${orderFragment_1.ORDER_FRAGMENT}
`;
//# sourceMappingURL=order.js.map